<template>
  <div class="categoryPage">
    <div class="categoryPage__main">
      <div class="categoryPage__main__title">
        <h1 class="large-title">{{this.title}}</h1>
      </div>
      <div class="categoryPage__main__header">
        <div class="categoryPage__main__header__filter">
          <slot name="filter"></slot>
        </div>
        <div class="categoryPage__main__header__sort">
          <span class="subhead">Sort By : </span>
          <div class="sort">
            <slot name="sort"></slot>
          </div>
        </div>
      </div>
      <div class="categoryPage__main__subheader" v-if="collection.length > 0">
        <div class="collection__header">
          <h2 class="small-title">Collection in {{this.title}}</h2>
          <button class="link desktop" @click.stop="allCollection()">See all <span class="ic-right"><i class="adx-ic_chevron_right"></i></span></button>
        </div>
        <slot name="collection"></slot>
        <button class="btn-block secondary mobile small-font" @click.stop="allCollection()">See all ({{totalCollection}}+)</button>
      </div>
      <div class="categoryPage__main__listitem">
        <h2 class="small-title">Listing in {{this.title}}</h2>
        <slot name="listitem"></slot>
      </div>
    </div>
    <div class="categoryPage__rightside">
      <div class="categoryPage__rightside__quickfilter">
        <slot name="quickfilter"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'adx-category-page',
  props: {
    title: {
      required: false
    },
    collection: {
      required: false
    },
    totalCollection: {
      required: false
    }
  },
  methods: {
    allCollection() {
      this.$router.push({ name: 'collectioncategory', params: { category: this.title.toLowerCase() } })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>